export default __webpack_public_path__ + "static/media/our-story-img13.d9321fd6.jpg";